import { render } from "./OcorrenciaArquivo.vue?vue&type=template&id=0061ab01&scoped=true&ts=true"
import script from "./OcorrenciaArquivo.vue?vue&type=script&lang=ts"
export * from "./OcorrenciaArquivo.vue?vue&type=script&lang=ts"

import "./OcorrenciaArquivo.vue?vue&type=style&index=0&id=0061ab01&scoped=true&lang=css"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0061ab01"]])

export default __exports__